import { UserOptionLabelByPartnerStatus } from "components";
import { merchantListService } from "services";
import { onlyMaxAlphaNumeric20 } from "validators";

const loadOptions = async (pattern, prevOptions, { page }) => {
	try {
		let agents = await merchantListService.getAgentList(
			pattern,
			page,
			false,
		);

		const hasMore =
			prevOptions.length + agents.agents.length < agents.count;

		const agentOptions = agents.agents?.map(item => {
			return {
				...item,
			};
		});

		return {
			options: agentOptions,
			hasMore,
			additional: {
				page: page + 1,
			},
		};
	} catch {
		return { options: [] };
	}
};

const agentDdlColumn = () => ({
	name: "agents",
	type: "select" as const,
	loadOptions,
	getOptionLabel: UserOptionLabelByPartnerStatus,
	getOptionValue: option => option.id,
	placeholder: "Agent Name",
	normalize: onlyMaxAlphaNumeric20,
	isMultiValue: true,
});

export default agentDdlColumn;
